import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const container = cn("flex flex-col min-h-[calc(100vh-4rem)]", "bg-background");

const headerSection = "px-4 pt-4 sm:px-6 sm:pt-6 shrink-0";

const centerSection = "flex-1 flex items-center justify-center p-4 md:p-8";

const gridContainer = "grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl";

const scrapingCard = cn(
  "relative overflow-hidden flex flex-col items-center justify-center p-8 md:p-10 cursor-pointer text-center",
  "border border-border",
  "transition-all duration-300",
  "hover:border-brand-purple/40",
);

const paymentCard = cn(
  "relative overflow-hidden flex flex-col items-center justify-center p-8 md:p-10 cursor-pointer text-center",
  "border border-border",
  "transition-all duration-300",
  "hover:border-primary/40",
);

const iconWrapper = cn(
  "flex items-center justify-center rounded-2xl p-4 mb-6",
  "bg-brand-purple/10 text-brand-purple",
  "transition-transform duration-300 group-hover:scale-110",
);

const iconWrapperGreen = cn(
  "flex items-center justify-center rounded-2xl p-4 mb-6",
  "bg-primary/10 text-primary",
  "transition-transform duration-300 group-hover:scale-110",
);

const cardTitle = cn("text-xl font-bold text-foreground mb-2", shared.transitionColors);

const cardDescription = cn("text-sm text-muted-foreground mb-6 text-center", "leading-relaxed");

const actionLink = cn("flex items-center gap-2 text-sm font-medium", "text-primary hover:text-primary/80", shared.transitionColors);

const actionLinkGreen = cn("flex items-center gap-2 text-sm font-medium", "text-success hover:text-success/80", shared.transitionColors);

const icon = "h-7 w-7";

const iconGreen = "h-7 w-7";

const iconSmall = "h-4 w-4 transition-transform duration-200 group-hover:translate-x-1";

export {
  container,
  headerSection,
  centerSection,
  gridContainer,
  scrapingCard,
  paymentCard,
  iconWrapper,
  iconWrapperGreen,
  cardTitle,
  cardDescription,
  actionLink,
  actionLinkGreen,
  icon,
  iconGreen,
  iconSmall,
};
